import { useTypesStore } from '../store/Types';
import { useTypesRender } from '../utils/useRender';
export var True = props => {
  var {
    True: Comp = {}
  } = useTypesStore();
  useTypesRender(Comp, props, 'True');
  return null;
};
True.displayName = 'JVR.True';